import { BehaviorSubject } from 'rxjs';
import { CookiesEnum } from './cookies.enum';

export class CookieManagementCookies {
    public static COOKIE_VERSION = 2;

    public cookiesSubjectMap = new Map<CookiesEnum, BehaviorSubject<boolean>>();

    constructor() {
        this.init();
    }

    setOneForEach(value: boolean): void {
        this.cookiesSubjectMap.forEach(source => source.next(value));
    }

    setEachForEach(cookiesBooleanMap: Map<CookiesEnum, boolean>): void {
        cookiesBooleanMap.forEach((source, $key)=> {
            this.cookiesSubjectMap.get($key).next(source);
        });
    }

    deserialize(cookieValue: string): void {
        const parseFormat = new RegExp('^all=(?<all>true|false)&technical=(?<technical>true|false)&analytics=(?<analytics>true|false)&marketing=(?<marketing>true|false)&v');
        const parsedGroups = cookieValue.match(parseFormat).groups;

        this.cookiesSubjectMap.forEach((source, $key) => {
            source.next(parsedGroups[$key] === 'true');
        });
    }

    serialize(majorVersion: number, minorVersion: number): string {
        return `all=${this.cookiesSubjectMap.get(CookiesEnum.all).value}&technical=${this.cookiesSubjectMap.get(CookiesEnum.technical).value}&analytics=${this.cookiesSubjectMap.get(CookiesEnum.analytics).value}&marketing=${this.cookiesSubjectMap.get(CookiesEnum.marketing).value}&v=${CookieManagementCookies.COOKIE_VERSION}.${majorVersion}.${minorVersion}`;
    }

    private init(): void {
        this.cookiesSubjectMap.set(CookiesEnum.all, new BehaviorSubject(false));
        this.cookiesSubjectMap.set(CookiesEnum.technical, new BehaviorSubject(true));
        this.cookiesSubjectMap.set(CookiesEnum.analytics, new BehaviorSubject(false));
        this.cookiesSubjectMap.set(CookiesEnum.marketing, new BehaviorSubject(false));
    }
}
